// src/pages/HerinneringenAfmeldenPage.js
//
// Afmeldpagina uit de herinneringsmail (/herinneringen/afmelden?t=<code>). Werkt zonder inloggen.
// Afmelden gebeurt pas bij een klik op de knop: mailscanners openen links vooraf, en dat mag
// niemand afmelden.
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import SEO from '../components/SEO';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;
const ONGELDIG = 'Deze afmeldlink is ongeldig of verlopen. Log in en pas je voorkeur aan via je profiel.';

function HerinneringenAfmeldenPage() {
  const [params] = useSearchParams();
  const token = params.get('t') || '';
  const [status, setStatus] = useState('laden'); // laden | ontvangt | afgemeld | ongeldig
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('ongeldig');
      return;
    }
    axios
      .get(`${STRAPI_URL}/api/herinneringen/status`, { params: { t: token } })
      .then((res) => setStatus(res.data?.afgemeld ? 'afgemeld' : 'ontvangt'))
      .catch(() => setStatus('ongeldig'));
  }, [token]);

  const zet = async (afmelden) => {
    setBezig(true);
    setFout('');
    try {
      await axios.post(`${STRAPI_URL}/api/herinneringen/${afmelden ? 'afmelden' : 'aanmelden'}`, { t: token });
      setStatus(afmelden ? 'afgemeld' : 'ontvangt');
    } catch (error) {
      console.error('Afmelden herinneringen mislukt:', error);
      setFout('Afmelden lukte niet. Probeer het later opnieuw.');
    } finally {
      setBezig(false);
    }
  };

  return (
    <div className="page-container">
      <SEO title="Herinneringen | Doorloopjes" noindex />
      <main className="profile-page-container">
        <section className="profile-details-section">
          <h2>Herinneringen van Doorloopjes</h2>
          {status === 'laden' && <p>Even geduld...</p>}
          {status === 'ongeldig' && (
            <>
              <p>{ONGELDIG}</p>
              <Link to="/" className="btn-primary" style={{ textDecoration: 'none' }}>
                Naar doorloopjes.nl
              </Link>
            </>
          )}
          {status === 'ontvangt' && (
            <>
              <p>
                Ben je een tijd niet op Doorloopjes geweest? Dan sturen we je hooguit één mail met doorloopjes die bij je passen. Wil je deze herinneringen niet meer krijgen?
              </p>
              <button type="button" className="btn-save-changes" onClick={() => zet(true)} disabled={bezig}>
                Afmelden voor herinneringen
              </button>
            </>
          )}
          {status === 'afgemeld' && (
            <>
              <p>Je bent afgemeld. Je ontvangt geen herinneringen meer van Doorloopjes.</p>
              <button type="button" className="btn-save-changes" onClick={() => zet(false)} disabled={bezig}>
                Toch weer ontvangen
              </button>
            </>
          )}
          {fout && <p className="profile-message">{fout}</p>}
          {(status === 'ontvangt' || status === 'afgemeld') && (
            <p style={{ marginTop: '1.5rem', fontSize: '0.9rem' }}>
              Dit staat los van de nieuwsbrief. Daarvoor gebruik je de afmeldlink onderaan de nieuwsbrief.
            </p>
          )}
        </section>
      </main>
    </div>
  );
}

export default HerinneringenAfmeldenPage;
